import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Home = () => {
    return (
      <div>
        메인페이지
      </div>
    );
  };
  

export default Home;